// Path to Menu Mapper utility for Google Analytics
// This maps URL paths to meaningful Menu_Submenu names from the sidebar configuration

const MENU_ITEMS = [
  {
    name: "Dashboard",
    role: ["DASHBOARD"],
    submenu: [
      {
        name: 'D2C Freight',
        url: '/dashboard/B2C'
      },
      {
        name: 'PTL Freight',
        url: '/dashboard/B2B'
      }
    ]
  },
  {
    name: "D2C Shipments",
    url: `/orders`,
    role: ["B2C_ACCESS"],
    submenu: [{
      name: 'Forward Shipments',
      url: `/orders`
    },
    {
      name: 'Reverse Shipments',
      url: '/reverse-orders'
    },
    {
      name: 'Cancellation Pending Shipments',
      url: '/cancellation-pending-orders'
    },
    {
      name: 'Bulk Tracking',
      url: '/bulk-tracking'
    }
    ]
  },
  {
    name: "PTL Shipments",
    url: `/ptl-shipments`,
    role: ["PTL_ACCESS"],
    submenu: [
      {
        name: 'Quick Pickup Request',
        url: '/quick-pickup-requests',
      },
      {
        name: 'Detailed Pickup Request',
        url: '/create-pickup-order',
      },
      {
        name: 'Pickup Requests',
        url: '/ptl-pickup-requests'
      },
      {
        name: 'All Shipments',
        url: `/ptl-shipments`
      },
      {
        name: 'Open Shipments',
        url: `/open-shipment`
      },
      {
        name: 'Upload For Tracking',
        url: '/B2Buploads'
      },
      {
        name: 'Upload For Tracking V2',
        url: '/b2b_tracking_upload'
      },
      {
        name: 'Upload For Manifestation',
        url: '/b2b_create_upload'
      },
      {
        name: 'Upload Additional Charges',
        url: '/b2b_charges_upload'
      },
      {
        name: 'Appointment Deliveries',
        url: '/ptl-appointment-deliveries'
      },
      {
        name: 'Under Process (Stuck) Shipments',
        url: '/ptl-under-process'
      },
    ]
  },
  {
    name: "NDR",
    url: '/pending-ndr',
    role: ["NDR"],
    submenu: [{
      name: 'Open NDR',
      url: '/pending-ndr'
    },
    {
      name: 'Closed NDR',
      url: '/closed-ndr'
    },
    {
      name: 'Bulk Upload',
      url: '/ndr-bulk-upload'
    },
    {
      name: 'Call Recordings',
      url: '/ndr-calls'
    },
    {
      name: 'WhatsApp Automation',
      url: '/wa-automation'
    },
    ]
  },
  {
    name: "NPR",
    url: '/pending-npr',
    role: ["NDR"],
    submenu: [{
      name: 'Open NPR',
      url: '/pending-npr'
    },
    {
      name: 'Closed NPR',
      url: '/closed-npr'
    },
    {
      name: 'Bulk Upload',
      url: '/npr-bulk-upload'
    },
    {
      name: 'Call Recordings',
      url: '/npr-calls'
    },
    ]
  },
  {
    name: "Unprocessed Orders",
    url: `/unprocessed-orders-forward`,
    role: ["ORDERS"],
    submenu: [{
      name: 'Forward Shipments',
      url: `/unprocessed-orders-forward`
    },
    {
      name: 'Reverse Shipments',
      url: '/unprocessed-orders-reverse'
    }]
  },
  {
    name: "Channel Orders",
    url: '/channel-orders',
    role: ["ORDERS"],
  },
  {
    name: "Masters",
    url: `/merchants`,
    role: ["INTERNAL"],
    submenu: [{
      name: 'Merchants',
      url: `/merchants`
    },
    {
      name: 'COD Remittance For All Merchant',
      url: '/cod-remittance-for-all-merchant'
    },
    {
      name: 'Lost And Damaged',
      url: '/lost-damage'
    },
    {
      name: 'Credit Note',
      url: '/credit-note'
    },
    {
      name: 'Product Master',
      url: '/product-master'
    },
    {
      name: 'Courier Master',
      url: '/couriers'
    },
    {
      name: 'Default Merchant Pricing',
      url: '/default-pricing'
    },
    {
      name: 'Merchant Invoice',
      url: '/merchant_invoice'
    },
    {
      name: 'COD Reconciliation',
      url: '/cod-reconciliation'
    },
    {
      name: 'Pickup Locations',
      url: '/pickup-locations'
    },
    {
      name: 'Delivery Locations',
      url: '/delivery-locations'
    },
    {
      name: 'Merchant Transactions',
      url: '/merchant-transactions'
    },
    {
      name: 'Courier COD Reconcilation',
      url: '/courier-cod-reconciliation'
    },
    {
      name: 'Courier Invoice Reconcilation',
      url: '/courier-invoice-recon'
    },
    {
      name: 'Notifications',
      url: '/notification'
    },
    {
      name: 'Insurance Order Status',
      url: '/insurance-order-status'
    },
    ]
  },
  {
    name: "User Management",
    url: `/user-management`,
    role: ["USER_SAVE", "USER_RO"],
  },
  {
    name: "Tools",
    url: "/serviceability",
    role: ["TOOLS"],
    submenu: [{
      name: "Serviceability",
      url: `/serviceability`
    },
    {
      name: 'Zone Mapping',
      url: '/zone'
    },
    {
      name: 'Invoice/Label',
      url: '/bulk-invoice-generate'
    },
    {
      name: 'Merchant Pricing Errors',
      url: '/merchant-pricing-missing'
    },
    {
      name: 'D2C Manual Status Update',
      url: '/d2c/operations/manual-status-update'
    },
    {
      name: 'PTL Manual Status Update',
      url: '/ptl/operations/manual-status-update'
    },
    {
      name: 'Courier Pricing Errors',
      url: '/courier-pricing-missing'
    },
    {
      name: 'Rate Calculator',
      url: '/shipment-rate-calculator'
    },
    {
      name: 'VAS Invoicing',
      url: '/vas-invoicing'
    },
    {
      name: 'Download MIS from AWB',
      url: '/awb-based-mis'
    },
    {
      name: 'Download POD from AWB',
      url: '/awb-based-pod'
    },
    {
      name: 'Sorter Image',
      url: '/sorter-image'
    },
    {
      name: 'AWB EDD Details',
      url: '/edd-details'
    },
    {
      name: 'QC Carrier Mapping',
      url: '/qc-mapping'
    },
    {
      name: 'Reverse QC Coverage',
      url: '/qc-monitor'
    },
    {
      name: 'Carrier Logs',
      url: '/carrier-logs'
    },
    {
      name: 'Label Configuration',
      url: '/label-config'
    },
    ]
  },
  {
    name: "Reports",
    url: '/reports',
    role: ["REPORTS"],
  },
  {
    name: "Finance",
    url: '/wallet',
    role: ["FINANCE"],
    submenu: [{
      name: 'Wallet Configuration',
      url: '/wallet',
    },
    {
      name: 'Update Offline Wallet',
      url: '/offline-payment'
    },
    {
      name: 'Merchant Credit Limit',
      url: '/credit-limit',
    },
    {
      name: 'Merchant COD Config',
      url: '/cod-merchantConfig',
    },
    {
      name: 'Credit Note',
      url: '/credit-note-finance'
    },
    {
      name: 'Lost And Damaged',
      url: '/lost-damage-finance'
    },
    {
      name: 'Merchant Invoice',
      url: '/finance-merchant-invoice'
    },
    {
      name: 'COD Reconciliation',
      url: '/reconciliation'
    },
    {
      name: 'COD Remittance',
      url: '/cod-remittance'
    },
    {
      name: 'Payment Details',
      url: '/payment-details'
    },
    ]
  },
  {
    name: "Uploads",
    url: '/uploads',
    role: ["INTERNAL"],
    submenu: [
      {
        name: 'Serviceability ',
        url: '/uploads'
      },
      {
        name: 'Courier COD',
        url: '/cod-upload',
      },
      {
        name: 'PODs',
        url: '/pods-uploads'
      },
      {
        name: 'Insert missing status',
        url: '/bulk-status-upload'
      },
      {
        name: 'Bulk EDD Upload',
        url: '/edd-upload'
      },
      {
        name: 'NDR Automated Rule',
        url: '/ndr-automated-rule'
      },
      {
        name: 'Update Order History',
        url: '/update-order-history'
      },
    ]
  },
  {
    name: "Courier Weight Freeze",
    url: '/weightfreeze-upload',
    role: ["WEIGHT_DESC"],
    submenu: [
      {
        name: 'Courier Weight Freeze Upload',
        url: '/weightfreeze-upload'
      },
      {
        name: 'Courier Weight Freeze Details',
        url: '/weightfreeze-details',
      }
    ]
  },
  {
    name: "Weight Discrepancy",
    url: '/all-discrepancy',
    role: ["WEIGHT_DESC"],
    submenu: [
      {
        name: 'All Discrepancy',
        url: '/all-discrepancy'
      },
      {
        name: 'Bulk Image Upload ',
        url: '/bulk-image-upload'
      },
      {
        name: 'Courier MIS Upload ',
        url: '/courier-mis-upload'
      },
      {
        name: 'Bulk Action',
        url: '/weight-discrepancy-bulk-action'
      },
      {
        name: 'Image Link',
        url: '/image-link'
      }
    ]
  },
  {
    name: "Weight v2",
    url: '/weight/v2/disputes',
    role: ["WEIGHT_DESC"],
    submenu: [
      {
        name: 'Dispute Queue',
        url: '/weight/v2/disputes'
      },
      {
        name: 'Merchant Freeze Requests',
        url: '/weight/v2/freeze-requests'
      },
      {
        name: 'Dispute Settings',
        url: '/weight/v2/settings'
      }
    ]
  },
  {
    name: "Escalation Management",
    url: '/support',
    role: ["TOOLS"],
  },
  {
    name: "Escalation Management V2",
    url: '/tools/escalation-v2',
    role: ["TOOLS"],
  },
  {
    name: "Allocation Analytics",
    url: '/allocation-details',
    role: ["SA"],
    submenu: [
      {
        name: 'Analytics',
        url: '/allocation-analytics'
      },
      {
        name: 'All Shipments ',
        url: '/all-shipments'
      },
    ]
  },
  {
    name: "Restricted",
    url: '/dws-config',
    role: ["AP_RESTRICTED"],
    submenu: [
      {
        name: 'CustomDWS Configuration',
        url: '/dws-config'
      },
    ]
  },
  {
    name: "Super Admin",
    url: '/merchant-webhooks',
    role: ["SA"],
    submenu: [
      {
        name: 'WebHooks',
        url: '/merchant-webhooks'
      },
      {
        name: 'Find Logs',
        url: '/shipping-label'
      },
      {
        name: 'Bulk Cancellation',
        url: '/bulk-cancellation'
      },
      {
        name: 'Merchant Config',
        url: '/merchant-config'
      },
      {
        name: 'Refresh URL',
        url: '/refresh-url'
      },
      {
        name: 'Upload File Ref',
        url: '/upload-file-refs'
      },
      {
        name: 'Update Merchant',
        url: '/update-merchant-detail'
      },
      {
        name: 'Notification Audit',
        url: '/notify-content-audit'
      },
      {
        name: 'Default Upload',
        url: '/upload'
      },
      {
        name: 'Clear Cache',
        url: '/cache'
      },
      {
        name: 'Clear Wallet Cache',
        url: '/clear-wallet-cache'
      },
      {
        name: 'Zone Copy',
        url: '/copy-zone'
      },
      {
        name: 'Direct Courier Config',
        url: '/courier-config'
      },
      {
        name: 'Courier Status Map',
        url: '/courier-status-map'
      },
      {
        name: 'SY Configuration',
        url: '/sy-config'
      },
      {
        name: 'Configuration',
        url: '/config'
      },
      {
        name: 'Insurance Configuration',
        url: '/insurance-config'
      },
    ]
  },
];

/**
 * Maps a URL path to a meaningful page name in "Menu_Submenu" format
 * @param {string} pathname - The current URL path
 * @returns {string} - Formatted page name like "Dashboard_D2C Freight" or just "Dashboard" for main menu items
 */
export function getPageNameFromPath(pathname) {
  // Remove leading slash and any query parameters
  const cleanPath = pathname.replace(/^\/+/, '').split('?')[0];

  // Handle root path
  if (!cleanPath || cleanPath === '' || cleanPath === '/') {
    return 'Dashboard_D2C Freight'; // Default to dashboard
  }

  // Find matching menu item - prioritize submenu matches over main menu matches
  for (const menu of MENU_ITEMS) {
    // Check submenu items first (more specific matches)
    if (menu.submenu) {
      for (const submenu of menu.submenu) {
        if (pathname === submenu.url) {
          return `${menu.name}_${submenu.name}`;
        }
      }
    }

    // Check if this is a direct menu match (no submenu or no submenu match found)
    if (menu.url && pathname === menu.url) {
      return menu.name; // Return just the menu name for main items without submenus
    }
  }

  // If no exact match found, try partial matching (for dynamic routes)
  for (const menu of MENU_ITEMS) {
    // Check submenu partial matches first
    if (menu.submenu) {
      for (const submenu of menu.submenu) {
        if (pathname.startsWith(submenu.url) && submenu.url !== '/') {
          return `${menu.name}_${submenu.name}`;
        }
      }
    }

    // Check main menu partial matches
    if (menu.url && pathname.startsWith(menu.url) && menu.url !== '/') {
      return menu.name;
    }
  }

  // Fallback: convert path to readable format
  const pathParts = pathname.split('/').filter(part => part);
  if (pathParts.length === 0) {
    return 'Dashboard';
  }

  // Convert kebab-case to Title Case
  const formatName = (str) => {
    return str
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  if (pathParts.length === 1) {
    return formatName(pathParts[0]);
  } else {
    return `${formatName(pathParts[0])}_${formatName(pathParts[1])}`;
  }
}

/**
 * Gets the main menu name for a given path
 * @param {string} pathname - The current URL path
 * @returns {string} - Main menu name
 */
export function getMainMenuFromPath(pathname) {
  for (const menu of MENU_ITEMS) {
    if (menu.url && pathname === menu.url) {
      return menu.name;
    }

    if (menu.submenu) {
      for (const submenu of menu.submenu) {
        if (pathname === submenu.url) {
          return menu.name;
        }
      }
    }
  }

  // Fallback for partial matches
  for (const menu of MENU_ITEMS) {
    if (menu.submenu) {
      for (const submenu of menu.submenu) {
        if (pathname.startsWith(submenu.url) && submenu.url !== '/') {
          return menu.name;
        }
      }
    }

    if (menu.url && pathname.startsWith(menu.url) && menu.url !== '/') {
      return menu.name;
    }
  }

  return 'Unknown';
}

/**
 * Gets the submenu name for a given path
 * @param {string} pathname - The current URL path
 * @returns {string|null} - Submenu name or null if no submenu
 */
export function getSubmenuFromPath(pathname) {
  for (const menu of MENU_ITEMS) {
    if (menu.submenu) {
      for (const submenu of menu.submenu) {
        if (pathname === submenu.url || (pathname.startsWith(submenu.url) && submenu.url !== '/')) {
          return submenu.name;
        }
      }
    }
  }

  return null;
} 